// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {CSSProperties} from 'react';
import styles from './cta.module.less';
import cn from 'classnames';
import {Editor} from '../../../shared/editor/editor';
import {Install_btn} from '../ui/install_btn';

interface i_cta {
    cta_text?: string;
    no_redirect?: boolean;
    no_arrow?: boolean;
    height?: string;
    width?: string;
    unit?: string;
    download_vpn?: boolean;
}

interface i_cta_editor_props {
    value: i_cta;
    on_change: (new_value: i_cta)=>void;
}

export const Cta = (props: i_cta)=>{
  const install_btn_cls = cn('hola_btn hola_btn--lg hola_btn--round',
    'hola_btn--txt_colored hola_btn--no_jump', styles.cta,
    props.no_arrow && 'hola_btn-no_arrow');
  const dimensions = {
    '--width': `${props.width}${props.unit}`,
    '--height': `${props.height}${props.unit}`,
    } as CSSProperties;
  return <div className={styles.cta_wrapper} style={dimensions}>
    <Install_btn keep_btn_text text={props.cta_text}
      className={cn(install_btn_cls)}
      no_redirect={props.no_redirect}
      download_vpn={props.download_vpn}/>
    </div>;
};

export const Cta_Editor = (props: i_cta_editor_props)=>{
  const {value = {cta_text: '', no_redirect: false, no_arrow: false,
      height: '230', width: '48', unit: 'px', download_vpn: false},
      on_change} = props;
  type editor_key = keyof i_cta;
  type editor_type = 'text' | 'textarea' | 'number' | 'boolean' | 'selector';
  const editors = [
    ['cta_text', 'Call to action text', 'text'],
    ['height', 'Height', 'text'],
    ['width', 'Width', 'text'],
    ['unit', 'unit(px/rem/em)', 'text'],
    ['no_redirect', 'Redirect after download', 'boolean'],
    ['no_arrow', 'No arrow', 'boolean'],
    ['download_vpn', 'Download VPN', 'boolean']
  ].map(([key, label, type])=>({key: key as editor_key, label,
    type: type as editor_type}));
  return <Editor
    value={value}
    editors={editors}
    on_change={on_change}
    title="Cta"
  />;
};
